import { render, staticRenderFns } from "./FormatListBulletedType.vue?vue&type=template&id=2c42530c&"
import script from "./FormatListBulletedType.vue?vue&type=script&lang=js&"
export * from "./FormatListBulletedType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports